module.exports = __webpack_public_path__ + "static/image1-eb09ff37a368482a07155eb37fc68805.jpg";